import { titleize } from 'helpers/formatters/string_formats';

export const BUY_SIDE = 'buy_side';
export const SELL_SIDE = 'sell_side';
export const DUAL = 'dual';
export const UNIT_DOLLARS = 'unit_dollars';
export const UNIT_PERCENT = 'unit_percent';

export const calculationModes = {
  standard: 'standard',
  transactionSide: 'transactionSide',
};

export const calculationModeOptions = [
  { label: 'Standard', value: calculationModes.standard },
  { label: 'By Transaction Side', value: calculationModes.transactionSide },
];

export function newTransactionSideDetails(transactionSide, asPercent = false) {
  return {
    transactionSide,
    grossAmount: 0,
    grossPercent: 0,
    grossRate: 0,
    grossUnit: asPercent ? UNIT_PERCENT : UNIT_DOLLARS,
  };
}

export function setTransactionSideToDual(target) {
  target.transactionSide = DUAL;
  target.transactionSideDetails = [...(target.transactionSideDetails || [])];

  for (const transactionSide of [BUY_SIDE, SELL_SIDE]) {
    const details = target.transactionSideDetails.find(details => details.transactionSide === transactionSide);
    if (!details) {
      target.transactionSideDetails.push(newTransactionSideDetails(transactionSide));
    }
  }
}

export function getTransactionSideLabel(side, transactionSideOptions = []) {
  const option = transactionSideOptions.find(([value]) => value === side);
  return option ? option[1] : titleize(side);
}

export function getTransactionSideDetails(record, transactionSide) {
  return record.transactionSideDetails.find(
    details => details.transactionSide === transactionSide && !details._destroy
  );
}
